import { render, staticRenderFns } from "./AssignCards.vue?vue&type=template&id=c15e9e4c&scoped=true"
import script from "./AssignCards.vue?vue&type=script&lang=js"
export * from "./AssignCards.vue?vue&type=script&lang=js"
import style0 from "./AssignCards.vue?vue&type=style&index=0&id=c15e9e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15e9e4c",
  null
  
)

export default component.exports